@if (!loading) {
<div class="upload-document">
    <section class="mat-typography">
        <h2 mat-dialog-title>Upload Document <mat-icon mat-dialog-close
                class="material-symbols-outlined pull-right">close</mat-icon></h2>
        @if (selectedCustomer != null) {
        <span><b>Selected Customer: </b> {{ selectedCustomer["accountNumber"] + " | " + selectedCustomer["ref"]
            }}</span>
        }
        @if (selectedSupplier != null) {
        <span><b>Selected Supplier: </b> {{ selectedSupplier["AccountNo"] + " | " + selectedSupplier["Name"] }}</span>
        }
        @if (selectedProspective != null) {
            <span><b>Selected Prospective: </b> {{ selectedProspective["Name"] }}</span>
            }
        @if (selectedContractor != null) {
        <span><b>Selected Contractor: </b> {{ selectedContractor["AccountNumber"] + " | " +
            selectedContractor["ContractorRef"] }}</span>
        }
        <hr>
    </section>
    <br />
    <div class="selection-container">
        @if (isForContractorTab != null) {
        <div class="button-group-container">
            <p>Is this upload for a contractor?</p>
            <mat-button-toggle-group [formControl]="isForContractorTab">
                <mat-button-toggle [value]="true">Yes</mat-button-toggle>
                <mat-button-toggle [value]="false">No</mat-button-toggle>
            </mat-button-toggle-group>
        </div>
        <br />
        }
        @if (!loadingDropDowns) {
        <div class="top-row">
            <div [ngClass]="entryPage == 'default' ? 'inline-input-50' : 'inline-input-20'" class="pull-left">
                <mat-button-toggle-group [(ngModel)]="selectedOption" class="mb-3">
                    @if(entryPage === "default" || entryPage === "job") {
                        <mat-button-toggle [disabled]="entryPage === 'job'" value="customer">Customer</mat-button-toggle>
                    }
                    @if (entryPage === "default") {
                    <mat-button-toggle value="supplier">Supplier</mat-button-toggle>
                    }
                    @if (entryPage === "default") {
                    <mat-button-toggle value="prospective">Prospective</mat-button-toggle>
                    }
                    <mat-button-toggle [disabled]="entryPage === 'job' || entryPage === 'contractor'" value="contractor">Contractor</mat-button-toggle>
                </mat-button-toggle-group>
            </div>
            @if(selectedOption === "customer") {
                <div class="inline-input-50 pull-right">
                    <tools-autocomplete #customerInput [path]="'/customers/?allFuzzy=false'" [column]="'accountNumber'"
                        [detailsColumn]="'ref'" [sortColumn]="'accountNumber'" [sort]="true" [count]="10"
                        [placeholder]="'Select a customer'"
                        [checked]="selectedCustomer != null ? selectedCustomer['accountNumber'] : null"
                        (selected)="customerSelected($event);" [disabled]="customerDisabled" style="width: 100%">
                    </tools-autocomplete>
                </div>
            } @else if (selectedOption === "supplier") {
                <div class="inline-input-50 pull-right">
                    <tools-autocomplete #supplierInput [path]="'/suppliers/'" [column]="'Name'" [sortColumn]="'Name'"
                        [sort]="true" [count]="10" [placeholder]="'Select a supplier'"
                        [checked]="selectedSupplier != null ? selectedSupplier.Name : null"
                        (selected)="supplierSelected($event);" [disabled]="supplierDisabled" style="width: 100%">
                    </tools-autocomplete>
                </div>
            } @else if (selectedOption === "prospective") {
                <div class="inline-input-50 pull-right">
                    <tools-autocomplete #prospectiveInput [path]="'/prospectives/'" [column]="'Name'" [sortColumn]="'Name'"
                        [sort]="true" [count]="10" [placeholder]="'Select a prospective'"
                        [checked]="selectedProspective != null ? selectedProspective.Name : null"
                        (selected)="prospectiveSelected($event);" [disabled]="prospectiveDisabled" style="width: 100%">
                    </tools-autocomplete>
                </div>
            } @else if (selectedOption === "contractor") {
                <div class="inline-input-50 pull-right">
                    <tools-autocomplete #contractorInput [path]="'/contractors/'" [column]="'AccountNumber'"
                        [sortColumn]="'AccountNumber'" [sort]="true" [count]="10" [placeholder]="'Select a contractor'"
                        [checked]="selectedContractor != null ? selectedContractor.AccountNumber : null"
                        (selected)="contractorSelected($event)" [disabled]="contractorDisabled" style="width: 100%">
                    </tools-autocomplete>
                </div>
            }
        </div>
        }
    </div>

    @if (selectedCustomer != null || selectedSupplier != null || selectedContractor != null  || selectedProspective != null) {
    <div class="full-width-input">
        @if (showPreview && previewURL != null && previewURL != '') {
        <div class="preview-pane">
            <app-viewer [url]="previewURL">
            </app-viewer>
        </div>
        }
        <div class="main-content{{ showPreview && previewURL != '' ? '-preview' : '' }}">
            <div>
                @if (documents == null || documents.length == 0) {
                <div>
                    <div>Upload one or more documents:</div>
                    <div>*Multiple documents of the same sub type are allowed.</div>
                    <div class="uploadfilecontainer" (click)="!working ? fileInput.click() : null" appDragNDrop
                        (onFileDropped)="handleDroppedFiles($event);">
                        <input hidden type="file" id="fileInput" #fileInput
                            (change)="onFileInput($event.target, $event.target['files'])" multiple>
                        Drag or Click to Upload
                    </div>
                    <p class="uploadHelp">What file types are allowed? <mat-icon class="pointer"
                            (click)="viewExtensions();"
                            matTooltip="{{ allowedExtensionText }}">contact_support</mat-icon></p>
                </div>
                }
                @if (documents != null && documents.length > 0) {
                <div>
                    <p>Selected Document(s):</p>
                    @for (file of documentsArray; track file; let i = $index) {
                    <div class="files-list">
                        <p style="width: 100%;"> {{ file.name }} @if (!working) {
                            <span class="material-icons delete-icon"
                                (click)="deleteFile(i, documentsArray)">delete_forever</span>
                            }
                        </p>
                    </div>
                    }
                </div>
                }
            </div>

            <br />
            @if (departments != null && departments.length > 0) {
            <div class="input-center">
                <tools-searchable-combobox class="input-50" #departs [comboboxHeading]="'Select a department'"
                    [comboboxPlaceholderName]="'Find a department'" [unFilteredOptions]="departments"
                    [multipleAllowed]="false" [disabled]="working" [column]="'Name'" [additionalColumn]="'Acronym'"
                    [preSelected]="selectedDepartment != null ? [selectedDepartment] : []"
                    (notify)='departmentSelected($event)'>
                </tools-searchable-combobox>
            </div>
            }

            @if (selectedDepartment != null) {
                @if (selectedDepartment.MainDocumentClasses != null && selectedDepartment.MainDocumentClasses.length > 0) {
                <div class="input-center">
                    <tools-searchable-combobox class="input-50" [isRequired]="true" [multipleAllowed]="false"
                        [column]="'Name'" [comboboxHeading]="'Select a document type'"
                        [comboboxPlaceholderName]="'Find a document type'"
                        [unFilteredOptions]="selectedDepartment.MainDocumentClasses"
                        (notify)='documentTypeSelected($event)'>
                    </tools-searchable-combobox>
                </div>
                } @else {
                <mat-card style="background-color: #ffebee; color: #b71c1c; border-left: 5px solid #d32f2f; margin-bottom: 16px;">
                    <mat-card-title>Error</mat-card-title>
                    <mat-card-content>
                        <p>There are no document types associated with the selected department. Please go and add a document type first</p>
                    </mat-card-content>
                </mat-card>
                }
            }


            @if (selectedDocumentType != null && selectedDocumentType.SubClasses != null && selectedDocumentType.SubClasses.length > 0) {
            <div class="input-center">
                <tools-searchable-combobox class="input-50" [isRequired]="true" [column]="'Name'"
                    [multipleAllowed]="false" [comboboxHeading]="'Select a sub document type'"
                    [comboboxPlaceholderName]="'Find a sub document type'"
                    [unFilteredOptions]="selectedDocumentType.SubClasses"
                    [preSelected]="selectedSubDocumentType != null ? [selectedSubDocumentType] : []"
                    (notify)='subDocumentTypeSelected($event)'>
                </tools-searchable-combobox>
            </div>
            }

            <br />
            @if (selectedSubDocumentType != null || (selectedDepartment != null && selectedDocumentType != null && (selectedDocumentType.SubClasses == null || selectedDocumentType.SubClasses.length <= 0))) {
            <mat-checkbox class="center-checkbox" [(ngModel)]="acceptableCondition" [required]="true"
                [disabled]="working">
                I hereby confirm that the document(s) is readable and in an acceptable condition.
            </mat-checkbox>
            }
            <br />
            @if (entryPage != 'job' && isRelatedToJob != null && acceptableCondition) {
            <div class="button-group-container">
                <p>Is related to a job?</p>
                <mat-button-toggle-group [formControl]="isRelatedToJob">
                    <mat-button-toggle [value]="true">Yes</mat-button-toggle>
                    <mat-button-toggle [value]="false">No</mat-button-toggle>
                </mat-button-toggle-group>
            </div>
            <br />
            }

            @if (acceptableCondition) {
                <form [formGroup]="documentDetailsForm " class="form-input-center">
                    @if (documentDetailsForm.controls['documentDescription']) {
                    <mat-form-field class="form-input-50">
                        <mat-label>Document number/details</mat-label>
                        <input matInput formControlName="documentDescription">
                        @if (documentDetailsForm.controls['documentDescription'].errors?.['required'] &&
                        documentDetailsForm.controls['documentDescription'].touched) {
                        <mat-error>This field is required</mat-error>
                        }
                    </mat-form-field>
                    }
                    @if (jobNumbersArray.length>0) {
                    @for(job of jobNumbersArray.controls; track job; let i=$index){
                    <div class="job-selection">
                        @if (showJobText) {
                        <div class="jobNumberInput">
                            <mat-form-field subscriptSizing="dynamic" class="job-number-field">
                                <mat-label>Job Number</mat-label>
                                <input matInput [formControl]="job">
                                @if (job.errors?.['required'] &&
                                job.touched) {
                                <mat-error>This field is required</mat-error>
                                }@else if(job.errors?.['pattern'] && job.touched){
                                <mat-error>Invalid Job Number</mat-error>
                                }
                            </mat-form-field>
                            @if(i==0){
                            <button class="form-button" mat-icon-button (click)="createNewJobNumber()"
                                style="border: 0px;"><mat-icon>add</mat-icon></button>
                            }@else {
                            <button class="form-button" mat-icon-button (click)="removeJobNumber(i)"
                                style="border: 0px;"><mat-icon>remove</mat-icon></button>

                            }
                        </div>
                        }
                        @if (showJobDropdown && showJobText) {
                        <p>or</p>
                        }
                        @if (showJobDropdown && !job.disabled) {
                        <div class="input-center">
                            <tools-searchable-combobox class="form-input-50" [comboboxHeading]="'Select a Job'"
                                [comboboxPlaceholderName]="'Find a Job'" [multipleAllowed]="false" [isRequired]="true"
                                [preSelected]="data.job" [allAllowed]="false" [column]="'JobNumber'" [MenuClass]="'tall-select'"
                                [unFilteredOptions]="jobs" (notify)='jobSelected($event)'>
                            </tools-searchable-combobox>
                        </div>
                        }
                        @if (showJobDropdown && job.disabled) {
                        <div class="input-center">
                            <mat-form-field class="form-input-50">
                                <mat-label>Select a jobs</mat-label>
                                <mat-select [formControl]="job">
                                    @for (option of jobs; track option) {

                                    @if (option && option.JobNumber) {
                                    <mat-option [value]="option.JobNumber">{{ option.JobNumber }}</mat-option>
                                    }

                                    }
                                </mat-select>
                                @if (job.errors?.['required'] &&
                                job.touched) {
                                <mat-error>This field is required</mat-error>
                                }
                            </mat-form-field>
                        </div>
                        }
                    </div>
                    }
                    }
                    @if (documentDetailsForm.controls['inventoryNumber']) {
                    <mat-form-field class="form-input-50">
                        <mat-label>Inventory Number</mat-label>
                        <input matInput formControlName="inventoryNumber">
                    </mat-form-field>
                    }
                </form>
            }
            @if (documentDetailsForm.valid) {
            <mat-checkbox class="center-checkbox" [(ngModel)]="informationCorrect">I confirm that the above information is
                correct</mat-checkbox>
            <br />
            }
            <mat-dialog-actions class="center-checkbox">
                @if (entryData?.entryPage != undefined) {
                <button class="padded-btn" mat-raised-button type="button" mat-dialog-close><i class="material-icons">cancel</i> Cancel </button>
                }
                <button [disabled]="!informationCorrect || !documentDetailsForm.valid" class="padded-btn" mat-raised-button type="button"
                    (click)="submitDocument()"><i class="material-icons">done</i> Submit </button>
            </mat-dialog-actions>
        </div>
    </div>
    }
</div>
}
@if (loading) {
<div class="loading">
    <mat-spinner></mat-spinner>
</div>
}
